/**
 * Where the NexBorg Access app is got (C1-15). Android by its package id (`com.nexborg.access`); the App Store
 * by Apple's numeric id. The listing is India only, so its address keeps `/in/`: without a country Apple
 * looks in the US store and answers 404 in a browser.
 *
 * Shared since the Staff setup guide (G-2b, 2026-10-01): its last step prints the same links as the
 * employee-only page, and a staff module may not import from auth (rules/01 §1).
 */
export const MOBILE_APP_LINKS = {
  android: "https://play.google.com/store/apps/details?id=com.nexborg.access",
  ios: "https://apps.apple.com/in/app/nexborg-access/id6821894044",
  name: "NexBorg Access",
} as const;
